import { useQuery } from 'react-query'
import { serverConfigQuery } from './query'

export const useServerConfig = () => {
  const { data } = useQuery(serverConfigQuery)
  return data
}
